(function($) {

	function add_cart_item(variant_id, quantity, location){

		let url = ghostpress_params.ajax_url + "&action=add_variant_to_cart",
			data = {
				"variant_id": variant_id,
				"quantity": quantity,
				"location": location,
			}

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				jQuery( document ).trigger('cart_updated')
				jQuery(document).trigger('open_modal', ['cart'])
				jQuery( document ).trigger( 'gp_update_checkout' )

				// Datalayer
				let datalayer = response.data.datalayer
				datalayer.action = "add"

				$(data).each(function(i, field){
					if(field.name == "quantity"){
						datalayer.quantity = field.value
					}
				});

				$(document).trigger("ghostpress-cart-datalayer-push", [datalayer])

			})
	}

	function update_cart_item(){

		let data = JSON.parse($(this).attr('data-cart-update-item'))

		gp_ajax({
			url: ghostpress_params.ajax_url + "&action=update_variant_in_cart",
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				jQuery( document ).trigger('cart_updated')
				jQuery( document ).trigger( 'gp_update_checkout' )

				// Datalayer
				let datalayer = response.data.datalayer
				let quantity = data.quantity - data.current_quantity

				if(quantity > 0){
					datalayer.action = "add"
				}else{
					datalayer.action = "remove"
				}

				datalayer.quantity = Math.abs(quantity)

				$(document).trigger("ghostpress-cart-datalayer-push", [datalayer])

			})
	}

	// Cross-sell
	function init_cross_sell(){
		let $choose_variation = $(".cross-sell__choose_variation"),
			$button_choose_variation = $choose_variation.find("button"),
			$variations = $(".cross-sell__variations")


		$button_choose_variation.click(function(){
			$choose_variation.hide()
			$variations.show()
		})

		$(".cross-sell__variation").click(function(){
			var variation_id = $(this).data('variation-id')
			if(!variation_id){
				return
			}
			add_cart_item(variation_id, 1, "cart_cross_sell")
		})

	}

	function init_cart(){

		// Add item to cart
		$('#form-add-to-cart').off('submit').submit(function(e){
			e.preventDefault()
			add_cart_item($(this).find('[name="variant_id"]').val(), $(this).find('[name="quantity"]').val(), "product_page")
		})

		// Update cart item
		$('[data-cart-update-item]').off('click').click(update_cart_item)

		// Init cross-sell
		init_cross_sell()

	}

	// Init cart functions
	$(document).gp_ready(init_cart)

})(jQuery);
